define('Components/CagnotteComeInWidget/js/views/CagnotteComeInWidgetInstanceView',['jquery','WidgetInstanceView','template!Components/CagnotteComeInWidget/templates/default',

        'template!Components/CagnotteComeInWidget/templates/fidelity', 'app', 'hooks',
    ],
    function($,WidgetInstanceView,defaultTemplate, fidelityTemplate, app, hooks){
    return WidgetInstanceView.extend({
        name:'CagnotteComeInWidgetInstanceView',
        events: {
         'click .historiqueCagnotte':'historiqueCagnotteModal',
        },


        historiqueCagnotteModal:function () {

            hooks.execHook('LoyaltyHistoryView',null,function(LoyaltyHistoryView){
                var loyaltyView = new LoyaltyHistoryView();
                app.displayModal(loyaltyView)
            });

        },

        getTemplate:function(){

            switch(this.model.getTemplate()){
                case 'fidelity':return fidelityTemplate; break;
                case 'default': default: return defaultTemplate; break;
            }
        },

    })
});
